import {captureException} from '@sentry/browser';
import {loadLocale} from './loadLocale';
import {initializeApp} from './initApp';

const container = document.getElementById('root');
if (container) {
  try {
    initializeApp(loadLocale, container);
  } catch (e) {
    captureException(new Error(`Unhandled error initializing widget: ${e}`));
    throw e;
  }
}
